import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '@core/services/api.service';
import { CreateComingSoonParking, CreateParkingRequest } from '@core/models/create-parking-request.model';
import { EditParkingRequest } from '@core/models/edit-parking-request.model';
import { ParkingListRequest, ParkingListResponse } from '@core/models/parking-list.model';
import { FacilityDetail } from '@core/models/facility-detail.model';
import { RestStop, SearchCriteria, VehicleTypeDetail } from '@core/models/vehicle-type-detail.model';
import { ParkingLotDetail } from '@core/models/parking-detail.model';
import { ParkingLotSlotsResponse } from '@core/models/parking-slot.model';
import { FileResponse } from '@core/models/file-response.model';
import { ParkingLot } from '@core/models/booking-flow-v1.model';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ParkingService {

  constructor(private readonly apiService: APIService, private readonly encryptStorage: EncryptionStorageService) { }

  setCurrentPage(page: number): void {
    this.encryptStorage.setItem('currentPage', JSON.stringify(page));
  }
  getCurrentPage(): number {
    const currentPage = this.encryptStorage.getItem('currentPage');
    if (currentPage) return +JSON.parse(currentPage);

    //return if current page not set
    return 1;
  }
  setSkipRecords(skipRecords: number): void {
    this.encryptStorage.setItem('skipRecords', JSON.stringify(skipRecords));
  }
  getSkipRecords(): number {
    const skipRecords = this.encryptStorage.getItem('skipRecords');
    if (skipRecords) return +JSON.parse(skipRecords);

    //return if current page not set
    return 0;
  }

  getVehicleTypeList(): Observable<VehicleTypeDetail[]> {
    return this.apiService.get<VehicleTypeDetail[]>('VehicleType/GetVehicleTypeList');
  }

  getParkingLotRestStop(req: SearchCriteria): Observable<RestStop[]> {
    return this.apiService.post<RestStop[]>('ParkingLot/GetParkingLotRestStop', req);
  }

  createParkingLot(data: CreateParkingRequest) {
    return this.apiService.post('ParkingLot/CreateParkingLot', data);
  }

  CreateComingSoonParking(data: CreateComingSoonParking) {
    return this.apiService.post('ParkingLot/CreateComingSoonParking', data);
  }

  deleteComingsoonParking(bookingId: string) {
    return this.apiService.post(`ParkingLot/DeleteComingSoonParking?id=${bookingId}`);
  }

  getFacilityList(): Observable<FacilityDetail[]> {
    return this.apiService.get<FacilityDetail[]>('ParkingLot/GetFacilityList')
  }
  imageUplaod(data: FormData): Observable<FileResponse> {
    return this.apiService.post<FileResponse>('User/ImageUpload', data);
  }
  getparkingDetailById(id: string): Observable<ParkingLotDetail> {
    return this.apiService.get<ParkingLotDetail>(`ParkingLot/GetParkingLotsById?id=${id}&isWeb=true` );
  }
  editParkingLot(data: EditParkingRequest) {
    return this.apiService.post('ParkingLot//EditParkingLot', data);
  }
  getParkingLotDetailsWithSlots(parkingLotId: string): Observable<ParkingLotSlotsResponse> {
    return this.apiService.get<ParkingLotSlotsResponse>(`ParkingLot/GetParkingLotDetailsWithSlots?parkingLotId=${parkingLotId}`)
  }
  getParkingLotsByManagerId(parkingListRequest: ParkingListRequest) {
    return this.apiService.post<ParkingListResponse>('ParkingLot/GetParkingLotsByManagerId', parkingListRequest);
  }
  getParkingLotsById(id: string): Observable<ParkingLotDetail> {
    return this.apiService.get<ParkingLotDetail>(`ParkingLot/GetParkingLotsById?id=${id}`);
  }
  updateParkingLotStatus(parkingLotId) {
    return this.apiService.postWithAllResponse(`ParkingLot/UpdateParkingLotStatus`, parkingLotId);
  }

  getParkingLotsByLocation(data:any): Observable<ParkingLot[]>{
    return this.apiService.post(`ParkingLot/GetParkingLotsByLocationWeb`,data)
  }

  getAvailableSlots(data: any){
    return this.apiService.post(`BookingSlot/GetAvaliableSlots`,data)
  }

  getBookingParkingSlot(data: any){
    return this.apiService.post(`BookingSlot/BookParkingSlot`,data)
  }
  getUserCredit(){
    return this.apiService.get(`BookingSlot/GetUserCredit`)
  }
  getUpdatedAmount(data: any){
    return this.apiService.postWithAllResponse(`BookingSlot/UpdateBookingCredit`,data)
  }
  getSearchedLocation(data: any):Observable<any> {
    return this.apiService.post(`ParkingLot/GetParkingLotsByLocationWeb`,data)
  }

  getCancelbookingById(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`BookingSlot/CancelBookingById`,data)
  }

  cancelBookingBySuperAdmin(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`BookingSlot/CancelBookingBySuperAdmin`,data)
  }
   cancelBookingBySuperAdminOneTime(data: any):Observable<any>{
    return this.apiService.postWithAllResponse(`BookingSlot/CancelOneTimeBooking`,data)
  }

  createParkingLotBookmarks(req) {
    return this.apiService.postWithAllResponse('ParkingLot/CreateParkingLotBookMark',req)
  }
  getParkingLotSpecialRateById(id){
    return this.apiService.get(`ParkingLot/GetParkingLotSpecialRateById?parkingLotId=${id}`);
  }
  openGateById(id: string) {
    return this.apiService.getWithAllResponse(`TruxGateLink/OpenGatesUsingParkingLotId?parkingLotId=${id}` );
  }
}